import { microwave } from '@round/api';
import { Skeleton } from '@round/ui-kit';
import InfluencerBadge from 'Modules/Influencer/components/AccountBadge/InfluencerBadge';
import styles from './AccountCell.module.css';
import { ReactComponent as LinkIcon } from 'assets/icons/Link.svg';
import { getMicrowaveInfluencerAccountData, getInfluencerAccountDisplayData } from './helpers';

type Props = {
    influencer?: microwave.MicrowaveInfluencer | null;
    influencerAccount?: microwave.MicrowaveInfluencerAccount | null;
    platform: microwave.Platform;
    imageUrl?: string;
    postUrl?: string;
    isLoading?: boolean;
};

const AccountCell = ({ influencer, influencerAccount, imageUrl, postUrl, platform, isLoading }: Props) => {
    if (isLoading) {
        return <Skeleton />;
    }

    const accountData = influencerAccount
        ? getInfluencerAccountDisplayData(influencerAccount)
        : influencer
          ? getMicrowaveInfluencerAccountData(influencer, platform)
          : null;

    if (!accountData) {
        return <>-</>;
    }

    return (
        <div className={styles.container}>
            <InfluencerBadge
                data={{
                    name: accountData.name || '-',
                    profileUrl: accountData.profileUrl || '',
                    username: accountData.username || '-',
                    imageUrl: imageUrl || '',
                }}
                isLoading={isLoading}
            />
            {postUrl && (
                <a href={postUrl} target="_blank" rel="noreferrer">
                    <LinkIcon className={styles.linkIcon} />
                </a>
            )}
        </div>
    );
};

export default AccountCell;
